import { Link } from "@tanstack/react-router";
import { CalendarRange, Percent, Plane, Sparkles } from "lucide-react";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";

const promotions = [
  {
    icon: Percent,
    tag: "Weekly deal",
    title: "Book 7 days, pay for 6",
    text: "Every weekly rental gets one day on us — applied automatically at checkout on any car in the fleet.",
    cta: "See weekly rates",
  },
  {
    icon: Plane,
    tag: "Airport pickup",
    title: "Free Otopeni delivery",
    text: "Land and drive. We meet you at Henri Coandă arrivals with the keys, no delivery fee, 24/7.",
    cta: "Book an airport car",
  },
  {
    icon: CalendarRange,
    tag: "Long term",
    title: "Up to 30% off monthly rentals",
    text: "Thirty days or more on a premium sedan or SUV, with servicing, insurance and road tax included.",
    cta: "Ask for a monthly quote",
  },
  {
    icon: Sparkles,
    tag: "Premium selection",
    title: "Free upgrade on weekends",
    text: "Reserve Friday to Monday and we lift you to the next class up whenever the fleet allows.",
    cta: "Browse premium cars",
  },
];

export function PromotionsCarousel() {
  return (
    <Carousel opts={{ align: "start", loop: true }} className="w-full">
      <CarouselContent className="-ml-4">
        {promotions.map((promo) => (
          <CarouselItem key={promo.title} className="pl-4 lg:basis-1/2">
            <article className="relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink p-8 text-ink-foreground shadow-lift">
              <span className="pointer-events-none absolute -right-16 -top-16 size-56 rounded-full bg-gold/20 blur-3xl" />
              <div className="relative flex items-center gap-3">
                <span className="grid size-11 place-items-center rounded-xl bg-gold text-gold-foreground">
                  <promo.icon className="size-5" />
                </span>
                <span className="eyebrow">{promo.tag}</span>
              </div>
              <h3 className="relative mt-6 font-display text-2xl font-bold leading-tight sm:text-3xl">
                {promo.title}
              </h3>
              <p className="relative mt-3 max-w-md text-sm leading-relaxed text-ink-foreground/70">
                {promo.text}
              </p>
              <div className="relative mt-7">
                <Button asChild variant="gold">
                  <Link to="/rentals">{promo.cta}</Link>
                </Button>
              </div>
            </article>
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="mt-6 flex justify-center gap-3">
        <CarouselPrevious className="static translate-y-0" />
        <CarouselNext className="static translate-y-0" />
      </div>
    </Carousel>
  );
}
